// ============================================================
// App - Root component with routing
// ============================================================

import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from './stores/authStore';
import { AppLayout } from './components/Layout';
import { LoginPage } from './pages/Login';
import { SignupPage } from './pages/Signup';
import { LandingPage } from './pages/Landing';
import { DashboardPage } from './pages/Dashboard';
import { JobsPage } from './pages/Jobs';
import { JobDetailPage } from './pages/JobDetail';
import { FormBuilderPage } from './pages/FormBuilder';
import { QuestionBankPage } from './pages/QuestionBank';
import { AssessmentsPage } from './pages/Assessments';
import { LeaderboardPage } from './pages/Leaderboard';
import { CandidateProfilePage } from './pages/CandidateProfile';
import { SettingsPage } from './pages/Settings';
import { AuditLogPage } from './pages/AuditLog';
import { BillingPage } from './pages/Billing';
import { PublicFormPage } from './pages/PublicForm';
import { AssessmentTakingPage } from './pages/AssessmentTaking';
import { FeaturesPage, AboutPage, ContactPage, TermsPage, PrivacyPage, FAQsPage } from './pages/PublicPages';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
    const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
    if (!isAuthenticated) return <Navigate to="/login" replace />;
    return <>{children}</>;
}

function LandingOrDashboard() {
    const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
    if (isAuthenticated) return <Navigate to="/dashboard" replace />;
    return <LandingPage />;
}

export default function App() {
    return (
        <BrowserRouter>
            <Routes>
                {/* Public routes */}
                <Route path="/" element={<LandingOrDashboard />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/signup" element={<SignupPage />} />
                <Route path="/apply/:token" element={<PublicFormPage />} />
                <Route path="/assessment/:token" element={<AssessmentTakingPage />} />
                <Route path="/features" element={<FeaturesPage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/terms" element={<TermsPage />} />
                <Route path="/privacy" element={<PrivacyPage />} />
                <Route path="/faqs" element={<FAQsPage />} />

                {/* Protected routes */}
                <Route element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
                    <Route path="/dashboard" element={<DashboardPage />} />
                    <Route path="/jobs" element={<JobsPage />} />
                    <Route path="/jobs/:id" element={<JobDetailPage />} />
                    <Route path="/forms/:id/builder" element={<FormBuilderPage />} />
                    <Route path="/questions" element={<QuestionBankPage />} />
                    <Route path="/assessments" element={<AssessmentsPage />} />
                    <Route path="/jobs/:jobId/leaderboard" element={<LeaderboardPage />} />
                    <Route path="/candidates/:id" element={<CandidateProfilePage />} />
                    <Route path="/settings" element={<SettingsPage />} />
                    <Route path="/audit-logs" element={<AuditLogPage />} />
                    <Route path="/billing" element={<BillingPage />} />
                </Route>
            </Routes>
        </BrowserRouter>
    );
}

